// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sidebar__otq-z {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #ffffff;
  font-family: "Inter Tight";
}

.Sidebar_brand__7TXrb {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
}

.Sidebar_brandLogo__GOjBN {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: #1b3a34;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
}

.Sidebar_brandLogoImg__perfK {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  display: block;
}

.Sidebar_brandText__E4xJS {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.Sidebar_brandLabel__Yj42g {
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #a3a3a3;
  line-height: 1.5;
}

.Sidebar_brandName__3iSiB {
  font-size: 14px;
  font-weight: 600;
  color: #0a0a0a;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Sidebar_search__Bsp5A {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 12px 8px;
  height: 36px;
  padding: 0 10px;
  border-radius: 4px;
  background: #f9f8f7;
}

.Sidebar_searchIcon__8dThR {
  color: #6f7173;
  flex-shrink: 0;
}

.Sidebar_searchInput__ItVBR {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 14px;
  color: #0a0a0a;
}
.Sidebar_searchInput__ItVBR::placeholder {
  color: #737373;
}

.Sidebar_searchKbd__yWlpI {
  font-size: 13px;
  color: #a3a3a3;
  flex-shrink: 0;
}

.Sidebar_searchKbdCmd__cy-Rr {
  font-size: 0.85em;
  margin-right: 1px;
  vertical-align: 1px;
}

.Sidebar_nav__e3Yjb {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 6px 12px 12px;
  scrollbar-width: thin;
  scrollbar-color: #dfdfdf transparent;
}
.Sidebar_nav__e3Yjb::-webkit-scrollbar {
  width: 6px;
}
.Sidebar_nav__e3Yjb::-webkit-scrollbar-thumb {
  background: #dfdfdf;
  border-radius: 3px;
}

.Sidebar_navSection__QHBaK + .Sidebar_navSection__QHBaK {
  margin-top: 8px;
}

.Sidebar_navTitle__kdkvj {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 14px 10px 6px;
  border: none;
  background: transparent;
  font-family: "Inter Tight";
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #a3a3a3;
  cursor: pointer;
  transition: color 0.12s ease;
}
.Sidebar_navTitle__kdkvj:hover {
  color: #737373;
}

.Sidebar_navTitleChevron__KyGBH {
  flex-shrink: 0;
  color: #8a8c8f;
  transition: transform 0.15s ease;
}

.Sidebar_navTitleChevronCollapsed__C5k89 {
  transform: rotate(-90deg);
}

.Sidebar_navList__DlGiB {
  list-style: none;
  margin: 0;
  padding: 0;
}

.Sidebar_navLink__dhnNx {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  margin-bottom: 2px;
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #737373;
  text-decoration: none;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.Sidebar_navLink__dhnNx:hover {
  background: #f9f8f7;
  color: #0a0a0a;
}

.Sidebar_navLinkActive__WtUeh {
  background: #ffffff;
  border-color: #f0efee;
  box-shadow: 0 1px 2px rgba(10, 13, 20, 0.03);
  color: #0a0a0a;
}
.Sidebar_navLinkActive__WtUeh .Sidebar_navIcon__groNr {
  color: #0a0a0a;
}

.Sidebar_navIcon__groNr {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  color: #6f7173;
}

.Sidebar_navText__gMDso {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Sidebar_navBadge__J8u8- {
  flex-shrink: 0;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: #1b3a34;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

.Sidebar_navArrow__IBdfD {
  margin-left: auto;
  color: #8a8c8f;
  flex-shrink: 0;
}

.Sidebar_footer__gnVpR {
  margin-top: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #ffffff;
  border-top: 1px solid #f0efee;
}

.Sidebar_createBtn__zRby2 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  background: #1b3a34;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease;
}
.Sidebar_createBtn__zRby2:hover {
  background: #17322d;
  color: #ffffff;
}

.Sidebar_userRow__kB6vY {
  display: flex;
  align-items: center;
  gap: 8px;
}

.Sidebar_userInfoLink__mh1uQ {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
  padding: 4px;
  margin: -4px;
  border-radius: 4px;
  color: inherit;
  text-decoration: none;
  transition: background 0.12s ease;
}
.Sidebar_userInfoLink__mh1uQ:hover {
  background: rgba(255, 90, 0, 0.08);
}

.Sidebar_userAvatar__yaaTd {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: rgba(27, 58, 52, 0.1);
  color: #1b3a34;
  font-size: 12px;
  font-weight: 600;
}

.Sidebar_userAvatarImg__jSxo8 {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.Sidebar_userText__4UCTV {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}

.Sidebar_userName__CF7X8 {
  font-size: 13px;
  font-weight: 500;
  color: #0a0a0a;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Sidebar_userEmail__c73Ae {
  font-size: 11px;
  color: #737373;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Sidebar_logoutBtn__w9faw {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  color: #8a8c8f;
  transition: background 0.12s ease, color 0.12s ease;
}
.Sidebar_logoutBtn__w9faw:hover {
  background: rgba(255, 90, 0, 0.08);
  color: #ff5a00;
}`, "",{"version":3,"sources":["webpack://./src/layouts/PortalLayout/Sidebar.module.scss","webpack://./src/layouts/PortalLayout/tokens.scss"],"names":[],"mappings":"AAOA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBCsBmB;EDrBnB,0BCwDS;AD9DX;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aCkCmB;ADzCrB;;AAUA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBCiBmB;EDhBnB,mBCdmB;EDenB,cCZmB;EDanB,eAAA;EACA,gBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBCKmB;EDJnB,cAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cChCmB;EDiCnB,gBAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,cCzCmB;ED0CnB,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,QCvBmB;EDwBnB,oBAAA;EACA,YAAA;EACA,eAAA;EACA,kBChCmB;EDiCnB,mBC9CmB;ADsCrB;;AAWA;EACE,cCvDmB;EDwDnB,cAAA;AARF;;AAWA;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,cCzEmB;ADiErB;AAUE;EACE,cC3EiB;ADmErB;;AAYA;EACE,eAAA;EACA,cChFmB;EDiFnB,cAAA;AATF;;AAYA;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;AATF;;AAaA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EAGA,qBAAA;EACA,oCAAA;AAZF;AAaE;EAAuB,UAAA;AAVzB;AAWE;EAA6B,mBCvFV;EDuF0C,kBAAA;AAP/D;;AAUA;EACE,eC9EmB;ADuErB;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QCrFmB;EDsFnB,WAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,0BC1ES;ED2ET,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cC3HmB;ED4HnB,eAAA;EACA,4BAAA;AAPF;AASE;EACE,cCjIiB;AD0HrB;;AAWA;EACE,cAAA;EACA,cCjImB;EDkInB,gCAAA;AARF;;AAYA;EACE,yBAAA;AATF;;AAYA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBCtImB;EDuInB,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cCjKmB;EDkKnB,qBAAA;EACA,4EAAA;AATF;AAWE;EACE,mBC5JiB;ED6JjB,cCxKiB;AD+JrB;;AAaA;EACE,mBCnKmB;EDoKnB,qBC/JmB;EDgKnB,4CC3ImB;ED4InB,cChLmB;ADsKrB;AAYE;EACE,cC9KiB;ADoKrB;;AAcA;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,cCrLmB;AD0KrB;;AAcA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAXF;;AAcA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBCrNmB;EDsNnB,cCnNmB;EDoNnB,eAAA;EACA,gBAAA;EACA,cAAA;AAXF;;AAcA;EACE,iBAAA;EACA,cCjNmB;EDkNnB,cAAA;AAXF;;AAeA;EACE,gBAAA;EACA,aCjMmB;EDkMnB,aAAA;EACA,sBAAA;EACA,SCpMmB;EDqMnB,mBCzNmB;ED0NnB,6BAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QC/MmB;EDgNnB,YAAA;EACA,mBCnPmB;EDoPnB,cCjPmB;EDkPnB,YAAA;EACA,kBCxNmB;EDyNnB,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,iCAAA;AAZF;AAcE;EACE,mBC7PiB;ED8PjB,cC5PiB;ADgPrB;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,QCnOmB;ADsNrB;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,QC1OmB;ED2OnB,SAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBCpPmB;EDqPnB,cAAA;EACA,qBAAA;EACA,iCAAA;AAdF;AAgBE;EACE,kCAAA;AAdJ;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iCAAA;EACA,cCtSmB;EDuSnB,eAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAfF;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AAfF;;AAkBA;EACE,eAAA;EACA,gBAAA;EACA,cCtTmB;EDuTnB,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,cC9TmB;ED+TnB,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBCrTmB;EDsTnB,cCvUmB;EDwUnB,mDAAA;AAfF;AAiBE;EACE,kCAAA;EACA,cC/TiB;ADgTrB","sourcesContent":["@import \"./tokens\";\n\n// =============================================================================\n// PortalLayout · Sidebar\n// Brand header · search · sectioned nav · footer (CTA + user)\n// =============================================================================\n\n.sidebar {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  background: $lux-surface;\n  font-family: $lux-font;\n}\n\n// ── Brand header ──────────────────────────────────────────────────────────────\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: $lux-space-4;\n}\n\n.brandLogo {\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: $lux-radius;\n  background: $lux-primary;\n  color: $lux-on-primary;\n  font-size: 13px;\n  font-weight: 600;\n  overflow: hidden;\n}\n\n.brandLogoImg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: $lux-radius;\n  display: block;\n}\n\n.brandText {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.brandLabel {\n  font-size: 10px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: $lux-text-tertiary;\n  line-height: 1.5;\n}\n\n.brandName {\n  font-size: 14px;\n  font-weight: 600;\n  color: $lux-text-primary;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// ── Search ────────────────────────────────────────────────────────────────────\n.search {\n  display: flex;\n  align-items: center;\n  gap: $lux-space-2;\n  margin: $lux-space-1 $lux-space-3 $lux-space-2;\n  height: 36px;\n  padding: 0 10px;\n  border-radius: $lux-radius;\n  background: $lux-surface-muted;\n}\n\n.searchIcon {\n  color: $lux-icon-secondary;\n  flex-shrink: 0;\n}\n\n.searchInput {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: 14px;\n  color: $lux-text-primary;\n\n  &::placeholder {\n    color: $lux-text-secondary;\n  }\n}\n\n.searchKbd {\n  font-size: 13px;\n  color: $lux-text-tertiary;\n  flex-shrink: 0;\n}\n\n.searchKbdCmd {\n  font-size: 0.85em;\n  margin-right: 1px;\n  vertical-align: 1px;\n}\n\n// ── Navigation ────────────────────────────────────────────────────────────────\n.nav {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: $lux-space-1 $lux-space-3 $lux-space-3;\n\n  // thin scrollbar\n  scrollbar-width: thin;\n  scrollbar-color: $lux-stroke-strong transparent;\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: $lux-stroke-strong; border-radius: 3px; }\n}\n\n.navSection + .navSection {\n  margin-top: $lux-space-2;\n}\n\n.navTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: $lux-space-2;\n  width: 100%;\n  padding: 14px 10px 6px;\n  border: none;\n  background: transparent;\n  font-family: $lux-font;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: $lux-text-tertiary;\n  cursor: pointer;\n  transition: color 0.12s ease;\n\n  &:hover {\n    color: $lux-text-secondary;\n  }\n}\n\n.navTitleChevron {\n  flex-shrink: 0;\n  color: $lux-icon-tertiary;\n  transition: transform 0.15s ease;\n}\n\n// collapsed → caret points right (open → points down)\n.navTitleChevronCollapsed {\n  transform: rotate(-90deg);\n}\n\n.navList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.navLink {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  margin-bottom: 2px;\n  border: 1px solid transparent;\n  border-radius: $lux-radius;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  color: $lux-text-secondary;\n  text-decoration: none;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover {\n    background: $lux-surface-muted;\n    color: $lux-text-primary;\n  }\n}\n\n.navLinkActive {\n  background: $lux-surface;\n  border-color: $lux-stroke;\n  box-shadow: $lux-shadow-xs;\n  color: $lux-text-primary;\n\n  .navIcon {\n    color: $lux-icon-primary;\n  }\n}\n\n.navIcon {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  color: $lux-icon-secondary;\n}\n\n.navText {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.navBadge {\n  flex-shrink: 0;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background: $lux-primary;\n  color: $lux-on-primary;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.navArrow {\n  margin-left: auto;\n  color: $lux-icon-tertiary;\n  flex-shrink: 0;\n}\n\n// ── Footer ────────────────────────────────────────────────────────────────────\n.footer {\n  margin-top: auto;\n  padding: $lux-space-3;\n  display: flex;\n  flex-direction: column;\n  gap: $lux-space-3;\n  background: $lux-surface;\n  border-top: 1px solid $lux-stroke;\n}\n\n.createBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: $lux-space-1;\n  height: 36px;\n  background: $lux-primary;\n  color: $lux-on-primary;\n  border: none;\n  border-radius: $lux-radius;\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: $lux-primary-600;\n    color: $lux-on-primary;\n  }\n}\n\n.userRow {\n  display: flex;\n  align-items: center;\n  gap: $lux-space-2;\n}\n\n// Clickable identity (avatar + name/email) → the account profile page.\n.userInfoLink {\n  display: flex;\n  align-items: center;\n  gap: $lux-space-2;\n  flex: 1;\n  min-width: 0;\n  padding: 4px;\n  margin: -4px;\n  border-radius: $lux-radius;\n  color: inherit;\n  text-decoration: none;\n  transition: background 0.12s ease;\n\n  &:hover {\n    background: rgba($lux-accent, 0.08);\n  }\n}\n\n.userAvatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: rgba($lux-primary, 0.1);\n  color: $lux-primary;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.userAvatarImg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.userText {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n}\n\n.userName {\n  font-size: 13px;\n  font-weight: 500;\n  color: $lux-text-primary;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.userEmail {\n  font-size: 11px;\n  color: $lux-text-secondary;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.logoutBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: $lux-radius;\n  color: $lux-icon-tertiary;\n  transition: background 0.12s ease, color 0.12s ease;\n\n  &:hover {\n    background: rgba($lux-accent, 0.08);\n    color: $lux-accent;\n  }\n}\n","// =============================================================================\n// Lumiere Ivory — Supplier Portal design tokens\n// -----------------------------------------------------------------------------\n// Single source of truth for the new theme, mapped 1:1 from the Figma variables\n// (Supplier V1 · node 84-45990). This is the foundation of the theme migration:\n// new/migrated components consume the `--lux-*` custom properties emitted by the\n// `lux-tokens` mixin (applied on the shell root in PortalLayout.module.scss), or\n// the `$lux-*` Sass variables directly inside the layout modules.\n//\n//   Figma variable            ->  token\n//   Primary/500 *             ->  $lux-primary\n//   Background/Surface/Default->  $lux-surface\n//   Stroke/Primary            ->  $lux-stroke\n//   Spacing/4 (8)             ->  $lux-space-2\n//   Radius/8                  ->  $lux-radius-lg\n// =============================================================================\n\n// ── Brand ────────────────────────────────────────────────────────────────────\n$lux-primary:        #1b3a34; // Primary/500 *\n$lux-primary-600:    #17322d; // Primary/600 (hover / pressed)\n$lux-primary-200:    #bdd3ce; // Primary/200 (tint)\n$lux-on-primary:     #ffffff;\n\n// ── Text ─────────────────────────────────────────────────────────────────────\n$lux-text-primary:   #0a0a0a; // Text/Primary\n$lux-text-secondary: #737373; // Text/Secondary\n$lux-text-tertiary:  #a3a3a3; // Text/Tertiery\n\n// ── Icon ─────────────────────────────────────────────────────────────────────\n$lux-icon-primary:   #0a0a0a; // Icon/Primary\n$lux-icon-secondary: #6f7173; // Icon/Secondary\n$lux-icon-tertiary:  #8a8c8f; // Icon/Tertiery\n\n// ── Surface ──────────────────────────────────────────────────────────────────\n$lux-surface:        #ffffff; // Background/Surface/Default\n$lux-surface-muted:  #f9f8f7; // Background/Surface/Neutral Lv1\n$lux-page-bg:        #f3f2f0; // page bg behind the floating panels\n\n// ── Stroke ───────────────────────────────────────────────────────────────────\n$lux-stroke:         #f0efee;                  // Stroke/Primary\n$lux-stroke-strong:  #dfdfdf;                  // Stroke/Tertiery\n$lux-panel-border:   rgba(115, 124, 127, 0.14); // floating panel hairline\n\n// ── Accent (danger / destructive) ────────────────────────────────────────────\n$lux-accent:         #ff5a00; // Orange/500 *\n$lux-accent-600:     #e85200; // Orange/600\n\n// ── Radius ───────────────────────────────────────────────────────────────────\n$lux-radius:         4px; // Radius/4 (controls, nav items)\n$lux-radius-lg:      8px; // Radius/8 (panels, cards)\n\n// ── Spacing ──────────────────────────────────────────────────────────────────\n$lux-space-1:        6px;  // Spacing/3\n$lux-space-2:        8px;  // Spacing/4\n$lux-space-3:        12px; // Spacing/5\n$lux-space-4:        16px;\n$lux-space-5:        20px;\n$lux-shell-gap:      8px;  // gap between the two floating panels\n\n// ── Elevation ────────────────────────────────────────────────────────────────\n$lux-shadow-xs:      0 1px 2px rgba(10, 13, 20, 0.03); // regular-shadow/x-small\n\n// ── Geometry ─────────────────────────────────────────────────────────────────\n$lux-sidebar-width:  270px;\n$lux-topbar-height:  64px;\n$lux-bp-collapse:    1139.98px; // below this the sidebar becomes a drawer\n\n// ── Typography ───────────────────────────────────────────────────────────────\n// Inter Tight only — no fallback of any kind (not even the generic sans-serif).\n$lux-font: 'Inter Tight';\n// type scale (size / weight / line-height) from the Figma text styles\n$lux-text-body:    14px; // Label/Small         500 / 20\n$lux-text-label:   12px; // Label/X-Small       500 / 16\n$lux-text-title-h5: 24px; // Title/H-5          600 / 32\n\n// -----------------------------------------------------------------------------\n// Emit the palette as CSS custom properties so migrated components can theme\n// against `var(--lux-*)` instead of hard-coding hexes. Applied once on the\n// shell root (.shell) — values cascade to every descendant.\n// -----------------------------------------------------------------------------\n@mixin lux-tokens {\n  --lux-primary: #{$lux-primary};\n  --lux-primary-600: #{$lux-primary-600};\n  --lux-primary-200: #{$lux-primary-200};\n  --lux-on-primary: #{$lux-on-primary};\n\n  --lux-text-primary: #{$lux-text-primary};\n  --lux-text-secondary: #{$lux-text-secondary};\n  --lux-text-tertiary: #{$lux-text-tertiary};\n\n  --lux-icon-primary: #{$lux-icon-primary};\n  --lux-icon-secondary: #{$lux-icon-secondary};\n  --lux-icon-tertiary: #{$lux-icon-tertiary};\n\n  --lux-surface: #{$lux-surface};\n  --lux-surface-muted: #{$lux-surface-muted};\n  --lux-page-bg: #{$lux-page-bg};\n\n  --lux-stroke: #{$lux-stroke};\n  --lux-stroke-strong: #{$lux-stroke-strong};\n  --lux-panel-border: #{$lux-panel-border};\n\n  --lux-accent: #{$lux-accent};\n  --lux-accent-600: #{$lux-accent-600};\n\n  --lux-radius: #{$lux-radius};\n  --lux-radius-lg: #{$lux-radius-lg};\n\n  --lux-space-1: #{$lux-space-1};\n  --lux-space-2: #{$lux-space-2};\n  --lux-space-3: #{$lux-space-3};\n  --lux-space-4: #{$lux-space-4};\n\n  --lux-shadow-xs: #{$lux-shadow-xs};\n  --lux-sidebar-width: #{$lux-sidebar-width};\n  --lux-topbar-height: #{$lux-topbar-height};\n\n  --lux-font: #{$lux-font};\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Sidebar_sidebar__otq-z`,
	"brand": `Sidebar_brand__7TXrb`,
	"brandLogo": `Sidebar_brandLogo__GOjBN`,
	"brandLogoImg": `Sidebar_brandLogoImg__perfK`,
	"brandText": `Sidebar_brandText__E4xJS`,
	"brandLabel": `Sidebar_brandLabel__Yj42g`,
	"brandName": `Sidebar_brandName__3iSiB`,
	"search": `Sidebar_search__Bsp5A`,
	"searchIcon": `Sidebar_searchIcon__8dThR`,
	"searchInput": `Sidebar_searchInput__ItVBR`,
	"searchKbd": `Sidebar_searchKbd__yWlpI`,
	"searchKbdCmd": `Sidebar_searchKbdCmd__cy-Rr`,
	"nav": `Sidebar_nav__e3Yjb`,
	"navSection": `Sidebar_navSection__QHBaK`,
	"navTitle": `Sidebar_navTitle__kdkvj`,
	"navTitleChevron": `Sidebar_navTitleChevron__KyGBH`,
	"navTitleChevronCollapsed": `Sidebar_navTitleChevronCollapsed__C5k89`,
	"navList": `Sidebar_navList__DlGiB`,
	"navLink": `Sidebar_navLink__dhnNx`,
	"navLinkActive": `Sidebar_navLinkActive__WtUeh`,
	"navIcon": `Sidebar_navIcon__groNr`,
	"navText": `Sidebar_navText__gMDso`,
	"navBadge": `Sidebar_navBadge__J8u8-`,
	"navArrow": `Sidebar_navArrow__IBdfD`,
	"footer": `Sidebar_footer__gnVpR`,
	"createBtn": `Sidebar_createBtn__zRby2`,
	"userRow": `Sidebar_userRow__kB6vY`,
	"userInfoLink": `Sidebar_userInfoLink__mh1uQ`,
	"userAvatar": `Sidebar_userAvatar__yaaTd`,
	"userAvatarImg": `Sidebar_userAvatarImg__jSxo8`,
	"userText": `Sidebar_userText__4UCTV`,
	"userName": `Sidebar_userName__CF7X8`,
	"userEmail": `Sidebar_userEmail__c73Ae`,
	"logoutBtn": `Sidebar_logoutBtn__w9faw`
};
export default ___CSS_LOADER_EXPORT___;
